















































import { defineComponent } from "@vue/composition-api";
import Vue from "vue";
import { Location } from "vue-router";
import BaseSpinner from "@/components/BaseSpinner";

Vue.component("BaseSpinner", BaseSpinner);

export default defineComponent({
  name: "BaseButton",
  props: {
    fullWidth: { type: Boolean },
    to: { type: Object as () => Location },
    href: { type: String },
    secondary: { type: Boolean },
    gradient: { type: Boolean },
    gradientText: { type: Boolean },
    outline: { type: Boolean },
    gray: { type: Boolean },
    green: { type: Boolean },
    red: { type: Boolean },
    white: { type: Boolean },
    small: { type: Boolean },
    extraSmall: { type: Boolean },
    round: { type: Boolean },
    disabled: { type: Boolean },
    transparent: { type: Boolean },
    loading: { type: Boolean },
    textLike: { type: Boolean },
  },
});
